export default __webpack_public_path__ + "static/media/attendance_logo.a044998d.svg";